import { http } from '@/http'

export default {
  list(employeeId) { return http.get(`/employee-documents/employee/${employeeId}`) },
  get(id)          { return http.get(`/employee-documents/${id}`) },
  upload(formData) { return http.post('/employee-documents/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } }) },
  download(id)     { return http.get(`/employee-documents/${id}/download`, { responseType: 'blob' }) },
  delete(id)       { return http.delete(`/employee-documents/${id}`) },
}
